import { Sub } from "@typescript-tea/core";
import * as State from "./state";
import { listenClearCache } from "../nats-ctors";

export function subscriptions(): Sub<State.Action> | undefined {
  return listenClearCache(e => State.Action.cacheCleared(e.serverName));
}
